// @flow

// Types
import type {
  DocumentsInput,
  Documents,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAncillary/consts/types"

export default function(documents: DocumentsInput): Documents {
  return {
    attachments: {
      ancillariesDocument: documents.attachments.ancillaries_document,
      fastTrackDocument: documents.attachments.fast_track_document,
    },
  }
}
